(function () {
  function getClosestIndex(value, positions) {
    var closestIndex = 0;
    var closestDistance = Infinity;

    positions.forEach(function (position, index) {
      var distance = Math.abs(position - value);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.partnerCarouselReady === 'true') return;

    var track = carousel.querySelector('[data-partner-carousel-track]');
    var items = track ? Array.prototype.slice.call(track.querySelectorAll('[data-partner-carousel-item]')) : [];
    var barsWrap = carousel.querySelector('[data-partner-carousel-bars]');
    var previousButton = carousel.querySelector('[data-partner-carousel-prev]');
    var nextButton = carousel.querySelector('[data-partner-carousel-next]');
    var controls = carousel.querySelector('.hanso-partner-carousel-controls');

    if (!track || !items.length || !barsWrap) {
      if (controls) controls.hidden = true;
      return;
    }

    carousel.dataset.partnerCarouselReady = 'true';
    var snapPoints = [];
    var bars = [];
    var frame = null;
    var dragState = null;
    var suppressClick = false;
    var caseStudies = carousel.hasAttribute('data-partner-carousel-cases');
    var activeIndex = 0;
    var trackWidth = track.clientWidth;

    function getItemPosition(item) {
      var trackBounds = track.getBoundingClientRect();
      var itemBounds = item.getBoundingClientRect();
      return track.scrollLeft + itemBounds.left - trackBounds.left;
    }

    function calculateSnapPoints() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var points = items.map(function (item) {
        return Math.max(0, Math.min(maxScroll, getItemPosition(item)));
      });

      if (maxScroll > 1) points.push(maxScroll);

      return points
        .sort(function (a, b) { return a - b; })
        .filter(function (point, index, allPoints) {
          return index === 0 || Math.abs(point - allPoints[index - 1]) > 2;
        });
    }

    function scrollToPosition(position, behavior) {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: position,
        behavior: reducedMotion ? 'instant' : behavior || 'smooth'
      });
    }

    function buildBars() {
      barsWrap.innerHTML = '';
      bars = snapPoints.map(function (position, index) {
        var bar = document.createElement('button');
        bar.type = 'button';
        bar.className = 'hanso-partner-carousel-bar';
        bar.setAttribute('aria-label', (caseStudies ? 'Go to case study ' : 'Go to carousel position ') + (index + 1));
        if (track.id) bar.setAttribute('aria-controls', track.id);
        bar.addEventListener('click', function () {
          scrollToPosition(position);
        });
        barsWrap.appendChild(bar);
        return bar;
      });
    }

    function updateControls() {
      if (!snapPoints.length) return;
      // A resize can clamp scrollLeft before the new snap points are calculated.
      if (caseStudies && track.clientWidth !== trackWidth) return;
      var index = getClosestIndex(track.scrollLeft, snapPoints);
      activeIndex = index;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      bars.forEach(function (bar, barIndex) {
        bar.classList.toggle('is-active', barIndex === index);
        bar.setAttribute('aria-current', barIndex === index ? 'true' : 'false');
      });
      if (caseStudies) {
        items.forEach(function (item, itemIndex) {
          item.toggleAttribute('inert', itemIndex !== index);
          item.setAttribute('aria-hidden', itemIndex === index ? 'false' : 'true');
        });
      }
      if (previousButton) previousButton.disabled = track.scrollLeft <= 1;
      if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function move(direction) {
      var index = getClosestIndex(track.scrollLeft, snapPoints);
      var targetIndex = Math.max(0, Math.min(snapPoints.length - 1, index + direction));
      scrollToPosition(snapPoints[targetIndex]);
    }

    function refresh() {
      var index = activeIndex;
      snapPoints = calculateSnapPoints();
      trackWidth = track.clientWidth;
      buildBars();
      if (controls) controls.hidden = snapPoints.length < 2;
      track.classList.toggle('is-scrollable', snapPoints.length > 1);
      if (caseStudies) scrollToPosition(snapPoints[Math.min(index, snapPoints.length - 1)], 'instant');
      updateControls();
    }

    if (previousButton) previousButton.addEventListener('click', function () { move(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { move(1); });

    track.addEventListener('keydown', function (event) {
      if (event.target !== track || !caseStudies) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        scrollToPosition(snapPoints[event.key === 'Home' ? 0 : snapPoints.length - 1]);
      }
    });

    carousel.addEventListener('shopify:block:select', function (event) {
      var item = event.target.closest('[data-partner-carousel-item]');
      if (item && items.indexOf(item) !== -1) scrollToPosition(getItemPosition(item), 'instant');
    });

    track.addEventListener('scroll', function () {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || snapPoints.length < 2) return;

      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: track.scrollLeft,
        moved: false
      };
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragState || dragState.pointerId !== event.pointerId) return;

      var distance = event.clientX - dragState.startX;
      if (Math.abs(distance) > 5 && !dragState.moved) {
        dragState.moved = true;
        track.classList.add('is-dragging');
        // Capture only an actual drag so ordinary case-study CTA clicks still reach the link.
        track.setPointerCapture(event.pointerId);
      }
      if (!dragState.moved) return;

      event.preventDefault();
      track.scrollLeft = dragState.startScrollLeft - distance;
    });

    function finishDrag(event) {
      if (!dragState || dragState.pointerId !== event.pointerId) return;

      var wasMoved = dragState.moved;
      dragState = null;
      track.classList.remove('is-dragging');

      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      if (wasMoved) {
        suppressClick = true;
        scrollToPosition(snapPoints[getClosestIndex(track.scrollLeft, snapPoints)]);
        window.setTimeout(function () { suppressClick = false; }, 0);
      }
    }

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);
    track.addEventListener('pointerleave', function (event) {
      if (dragState && !dragState.moved) finishDrag(event);
    });
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    track.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    var resizeFrame = null;
    window.addEventListener('resize', function () {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(refresh);
    }, { passive: true });

    refresh();
  }

  function initProgrammeLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-partner-programme]');
      if (!link) return;

      var programmeInput = document.querySelector('[data-partner-programme-input]');
      if (programmeInput) {
        programmeInput.value = link.dataset.partnerProgramme || '';
        programmeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function initProgrammeSelect(select) {
    if (!select || select.dataset.partnerProgrammeReady === 'true') return;

    var field = select.closest('[data-partner-field]');
    var customSelect = field ? field.querySelector('[data-partner-programme-select]') : null;
    var trigger = customSelect ? customSelect.querySelector('[data-partner-programme-trigger]') : null;
    var value = customSelect ? customSelect.querySelector('[data-partner-programme-value]') : null;
    var options = customSelect ? Array.prototype.slice.call(customSelect.querySelectorAll('[data-partner-programme-option]')) : [];
    if (!field || !customSelect || !trigger || !value || !options.length) return;

    select.dataset.partnerProgrammeReady = 'true';
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    field.classList.add('is-enhanced');
    var placeholder = select.options[0] ? select.options[0].textContent.trim() : '';

    function setOpen(isOpen, focusOption) {
      customSelect.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen && focusOption) {
        var selected = options.find(function (option) { return option.dataset.value === select.value; });
        (selected || options[0]).focus();
      }
    }

    function syncValue() {
      value.textContent = select.value || placeholder;
      options.forEach(function (option) {
        var selected = option.dataset.value === select.value;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    trigger.addEventListener('click', function () {
      setOpen(!customSelect.classList.contains('is-open'));
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        setOpen(true, true);
      } else if (event.key === 'Escape') {
        setOpen(false);
      }
    });

    options.forEach(function (option, index) {
      option.addEventListener('click', function () {
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setOpen(false);
        trigger.focus();
      });
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          trigger.focus();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
        }
      });
    });

    select.addEventListener('change', syncValue);
    document.addEventListener('click', function (event) {
      if (!customSelect.contains(event.target)) setOpen(false);
    });
    syncValue();
  }

  function initPartnerForm(form) {
    if (!form || form.dataset.partnerFormReady === 'true') return;
    form.dataset.partnerFormReady = 'true';
    form.noValidate = true;

    var workTypeInput = form.querySelector('[data-work-type-value]');
    var workTypeCheckboxes = Array.prototype.slice.call(form.querySelectorAll('[data-work-type-option]'));
    var selectAll = form.querySelector('[data-work-type-select-all]');
    var webhookConfig = form.querySelector('[data-partner-webhook-config]');
    var webhookStatus = form.querySelector('[data-partner-webhook-status]');
    var submitButton = form.querySelector('[data-partner-submit]');
    var submitLabel = submitButton ? submitButton.textContent.trim() : '';
    var webhookPending = false;
    var lastWebhookPayload = null;
    var resumeShopifySubmission = false;
    var webhookFields = [
      'programme',
      'business_brand_name',
      'first_name',
      'last_name',
      'phone',
      'email',
      'website_social_profiles',
      'work_type',
      'work_location',
      'business_description',
      'liability_insurance',
      'referral_source'
    ];

    function syncWorkTypes() {
      if (selectAll) {
        var selectable = workTypeCheckboxes.filter(function (checkbox) { return checkbox !== selectAll; });
        selectAll.checked = selectable.length > 0 && selectable.every(function (checkbox) { return checkbox.checked; });
      }

      if (workTypeInput) {
        workTypeInput.value = workTypeCheckboxes
          .filter(function (checkbox) { return checkbox !== selectAll && checkbox.checked; })
          .map(function (checkbox) { return checkbox.value; })
          .join(', ');
      }
    }

    if (selectAll) {
      selectAll.addEventListener('change', function () {
        workTypeCheckboxes.forEach(function (checkbox) {
          if (checkbox !== selectAll) checkbox.checked = selectAll.checked;
        });
        syncWorkTypes();
      });
    }

    workTypeCheckboxes.forEach(function (checkbox) {
      if (checkbox !== selectAll) checkbox.addEventListener('change', syncWorkTypes);
    });

    function validateContainer(container) {
      var isValid = true;
      var control = container.querySelector('input:not([type="hidden"]), select, textarea');
      var customTrigger = container.querySelector('[data-partner-programme-trigger]');

      if (container.hasAttribute('data-required-options')) {
        isValid = Array.prototype.some.call(container.querySelectorAll('input[type="checkbox"], input[type="radio"]'), function (option) {
          return option.checked && !option.hasAttribute('data-work-type-select-all');
        });
      } else if (control && control.required) {
        if (control.type === 'checkbox' || control.type === 'radio') {
          isValid = control.checked;
        } else {
          isValid = control.value.trim() !== '';
        }
      }

      if (isValid && control && control.type === 'email' && control.value.trim()) {
        isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(control.value.trim());
      }

      container.classList.toggle('is-error', !isValid);
      if (customTrigger) customTrigger.setAttribute('aria-invalid', isValid ? 'false' : 'true');
      return isValid;
    }

    function getWebhookPayload() {
      var formData = new FormData(form);

      return webhookFields.reduce(function (payload, fieldName) {
        var value = formData.get('contact[' + fieldName + ']');
        payload[fieldName] = value === null ? '' : String(value).trim();
        return payload;
      }, {});
    }

    function setSubmitting(isSubmitting) {
      if (!submitButton) return;
      submitButton.disabled = isSubmitting;
      submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      submitButton.textContent = isSubmitting
        ? webhookConfig.dataset.sendingLabel || 'Submitting...'
        : submitLabel;
    }

    function showWebhookError() {
      if (!webhookStatus) return;
      webhookStatus.textContent = webhookConfig.dataset.errorMessage || 'We could not submit your application. Please try again.';
      webhookStatus.hidden = false;
      webhookStatus.focus();
    }

    function prepareShopifySubmission() {
      return new Promise(function (resolve, reject) {
        var captcha = window.Shopify && window.Shopify.captcha;
        if (!captcha || typeof captcha.protect !== 'function') {
          reject(new Error('Shopify form protection is unavailable'));
          return;
        }

        var settled = false;
        var timeout = window.setTimeout(function () {
          settled = true;
          reject(new Error('Shopify form protection did not load'));
        }, 15000);

        try {
          captcha.protect(form, function () {
            if (settled) return;
            settled = true;
            window.clearTimeout(timeout);
            // Shopify replaces form.submit when protection is ready. Never bypass it.
            if (typeof form.submit !== 'function' || form.submit === HTMLFormElement.prototype.submit) {
              reject(new Error('Shopify form protection could not be initialized'));
              return;
            }
            resolve();
          });
        } catch (error) {
          settled = true;
          window.clearTimeout(timeout);
          reject(error);
        }
      });
    }

    form.addEventListener('submit', function (event) {
      if (resumeShopifySubmission) return;

      syncWorkTypes();
      var containers = Array.prototype.slice.call(form.querySelectorAll('[data-partner-field]'));
      var isValid = containers.map(validateContainer).every(Boolean);

      if (!isValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var firstError = form.querySelector('.is-error [data-partner-programme-trigger], .is-error input, .is-error select, .is-error textarea');
        if (firstError) firstError.focus();
        return;
      }

      var webhookUrl = webhookConfig ? webhookConfig.dataset.webhookUrl.trim() : '';
      if (!webhookUrl) return;

      event.preventDefault();
      // Hold Shopify's submit listeners until the asynchronous webhook has finished.
      event.stopImmediatePropagation();
      if (webhookPending) return;
      webhookPending = true;
      if (webhookStatus) webhookStatus.hidden = true;
      setSubmitting(true);

      var payload = JSON.stringify(getWebhookPayload());
      prepareShopifySubmission()
        .then(function () {
          // A CAPTCHA retry must not resend an already acknowledged CRM payload.
          if (lastWebhookPayload === payload) return;
          return fetch(webhookUrl, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: payload,
            keepalive: true
          }).then(function (response) {
            if (!response.ok) throw new Error('Make webhook returned HTTP ' + response.status);
            lastWebhookPayload = payload;
          });
        })
        .then(function () {
          webhookPending = false;
          setSubmitting(false);
          resumeShopifySubmission = true;
          try {
            form.requestSubmit();
          } finally {
            resumeShopifySubmission = false;
          }
        })
        .catch(function (error) {
          console.error('Partner application submission failed:', error);
          webhookPending = false;
          setSubmitting(false);
          showWebhookError();
        });
    }, true);

    form.addEventListener('input', function (event) {
      var container = event.target.closest('[data-partner-field]');
      if (container) validateContainer(container);
    });

    form.addEventListener('change', function (event) {
      var container = event.target.closest('[data-partner-field]');
      if (container) validateContainer(container);
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-partner-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-partner-programme-native]').forEach(initProgrammeSelect);
    root.querySelectorAll('.hanso-partner-form__form').forEach(initPartnerForm);
  }

  function ready() {
    init(document);
    initProgrammeLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
